import type { InteractionMonitoringOptions } from "@repo/monitoring/interaction";
import { amcPdpMonitoringSchema } from "./amcPdpMonitoringSchema";

export const amcPdpInteractionMonitoringOptions: InteractionMonitoringOptions = {
  schema: amcPdpMonitoringSchema,
  responseWindowMs: 2000,
  rageClickWindowMs: 2500,
  rageClickThreshold: 3,
};
